import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as refillsActions } from "reducers/refills";
import { routerActions } from "connected-react-router";
import Selector from "pages/_components/fields/formik/Selector";
import TextField from "pages/_components/fields/TextField";
import ProductSelector from "pages/_components/fields/formik/FormikProductSelector";
import Credential from "pages/_components/fields/credentials/Credential";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { Col, Row } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import Button from "pages/_components/Button";
import * as i18n from "util/i18n";
import { useEcheckAccountSelector } from "pages/echeck/hooks/useEcheckAccouts";
import GridTable from "pages/_components/GridTable/GridTable";

export const ARS = "ARS";
export const CHECKING_ACCOUNT = "CC";

const RefillsPage = () => {
    const { formRequest, refillsTicket } = useSelector((state) => state.refills);

    const { accountOptions, accounts, fetching } = useEcheckAccountSelector(ARS, CHECKING_ACCOUNT);
    const [businessState, setBusiness] = useState([]);
    const [businessCompany, setBusinessCompany] = useState([]);
    const dispatch = useDispatch();
    const initialValues = { p_0: "", p_1: "" };
    businessState.forEach((element) => {
        initialValues[`p_${element.position}`] = "";
    });

    useEffect(() => {
        dispatch(refillsActions.refillsGetForm());
    }, []);

    useEffect(() => {
        if (refillsTicket?.status === "SUCCESS") {
            dispatch(refillsActions.cleanRefillsTicket());
            dispatch(routerActions.push(`/Payment/refills/confirm`));
        } else if (refillsTicket?.status === "ERROR") {
            dispatch(refillsActions.cleanRefillsTicket());
        }
    }, [refillsTicket]);

    useEffect(() => {}, [businessState]);

    const getBusiness = () => {
        const business = [];

        if (formRequest != null) {
            formRequest.forEach((element) => {
                business.push({
                    value: element.name,
                    label: element.name,
                    code: element.code,
                    paymentModeId: element.paymentModeId,
                });
            });
        }

        return business;
    };

    // const getBusinessPlaceHolder = () => {
    //     if (formRequest != null) {
    //         return formRequest[0].name;
    //     }
    //     return "";
    // };

    const setBusinessState = (value) => {
        if (formRequest != null) {
            formRequest.forEach((element) => {
                if (element.name === value.empresa) {
                    setBusiness(element?.form);
                    setBusinessCompany(element);
                }
            });
        }
    };

    const getValuesComboBox = (values) => {
        const result = [];

        if (Object.entries(values) != null) {
            Object.entries(values).forEach((element) => {
                result.push({ value: element[0], label: element[1] });
            });
        }
        return result;
    };

    const getPlaceholderComboBox = (values) => {
        if (Object.entries(values) != null) {
            return Object.entries(values)[0][1];
        }
        return "";
    };

    const handleSubmit = (values) => {
        const completeDebitAccount = accounts.find((account) => account.productId === values.debitAccount);

        const formData = {
            ...values,
            amount: {
                quantity: values.p_1,
                currency: "ARS",
            },
            accountInfo: completeDebitAccount,
            business: businessState,
        };

        const codNroLinea = businessState[0].field;
        const codMonto = businessState[1].field;

        const dataForm = `{"${codNroLinea}":"${values.p_0}","${codMonto}":${values.p_1}}`;

        const obj = JSON.parse(dataForm);
        const rapipagoRequest = {
            paymentMethod: "PES",
            companyCode: businessCompany.code,
            companyName: businessCompany.name,
            paymentModeId: businessCompany.paymentModeId,
            form: obj,
        };

        dispatch(refillsActions.refillsFormData(formData));
        dispatch(refillsActions.refillsPreparePay(JSON.stringify(rapipagoRequest)));
    };

    const handleForm = (state, registro) => {
        let formData;
        if (state?.component === "TEXT_FIELD") {
            formData = (
                <GridTable.Data columnStart={registro || 2} rowStart={registro ? 1 : 3} columnWidth={5}>
                    <Field
                        component={TextField}
                        mode="edit"
                        name={`p_${state?.position}`}
                        type="text"
                        isFocused
                        labelnoI18n={state?.label}
                        maxLength={state?.length}
                        placeholderText={state?.label}
                        onlyNumbers
                        pattern="^[0-9]*$"
                    />
                </GridTable.Data>
            );
        }

        if (state?.component === "COMBO_BOX_ESTATICO") {
            formData = (
                <GridTable.Data columnStart={1} rowStart={registro} columnWidth={5}>
                    <Field
                        component={Selector}
                        label={state?.label}
                        name={state?.label}
                        options={getValuesComboBox(state?.values)}
                        placeholder={getPlaceholderComboBox(state?.values)}
                    />
                </GridTable.Data>
            );
        }
        if (state?.component === "HIDDEN_TEXT_FIELD") {
            formData = (
                <GridTable.Data columnStart={2} rowStart={4} columnWidth={5}>
                    <Field
                        component={Credential}
                        labelText="form.credential.password.label"
                        name={state?.label}
                        placeholderText="Ej: 120573"
                        type="password"
                    />
                </GridTable.Data>
            );
        }
        return formData;
    };

    const handleData = () => {
        let registro = 4;
        return businessState.map((state) => {
            registro += 3;
            if (state?.label !== "Importe") {
                return handleForm(state, registro);
            }
            return null;
        });
    };
    const handleDataImport = () =>
        businessState.map((state) => {
            if (state?.label === "Importe") {
                return handleForm(state, null);
            }
            return null;
        });

    const handleDisabled = (values) => {
        let data = true;
        if (Object.keys(values).length > 3) {
            Object.entries(values).forEach((element) => {
                const [key, value] = element;
                if (value === "") {
                    data = false;
                }
                return key;
            });
        } else {
            data = false;
        }
        return data;
    };

    return (
        <>
            <Notification scopeToShow="refillsForm" />
            <ResponsiveHeader id="refills.title" showLabel />
            <MainContainer fetching={fetching}>
                <Formik onSubmit={handleSubmit} initialValues={initialValues}>
                    {({ values }) => (
                        <Form>
                            <GridTable className="form">
                                <GridTable.Container columns={12} columnsTemplate="fixed">
                                    <GridTable.Data columnStart={2} columnWidth={5}>
                                        <Field
                                            component={Selector}
                                            label="Empresa"
                                            name="empresa"
                                            placeholder={i18n.get("global.select")}
                                            options={getBusiness()}
                                            onChange={setBusinessState(values)}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={2} rowStart={2} columnWidth={10}>
                                        <Field
                                            component={ProductSelector}
                                            name="debitAccount"
                                            label={i18n.get("massive.echeck.debit.account")}
                                            placeholder={i18n.get("global.select")}
                                            data={{ emptyOptionLabel: "", options: accountOptions }}
                                        />
                                    </GridTable.Data>
                                    {handleData()}
                                    {handleDataImport()}
                                </GridTable.Container>
                            </GridTable>
                            <Row className="form-actions no-print">
                                <Col xs={12} md={4} mdOffset={4}>
                                    <Button
                                        type="submit"
                                        className="btn-primary"
                                        label="global.continue"
                                        disabled={!handleDisabled(values)}
                                    />
                                </Col>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </MainContainer>
        </>
    );
};

export default RefillsPage;
